module.exports = __webpack_public_path__ + "img/kz.f1149d21.svg";